import { Typography, Box, List, ListItem, ListItemText } from '@mui/material';
// import { useTheme } from '@mui/material/styles';

const InbuiltNodeModules = () => {
    // const theme = useTheme();
    // const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box>
            <Typography variant="h5" gutterBottom>📦 Node Modules</Typography>
            <Typography variant="body1" gutterBottom>
                The following Node.js modules are available by default for both pre-request and post-response scripts:
            </Typography>
            <List dense>
                {["axios", "lodash", "chai", "node-fetch", "http", "https", "url"].map((module, index) => (
                    <ListItem key={index}><ListItemText primary={module} /></ListItem>
                ))}
            </List>
        </Box>
    )
};

export default InbuiltNodeModules;
